import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { ApiKey } from "types/generated";
import { formatApiSecretFile } from "utils/apiSecret";
import { downloadFile } from "utils/file";

type DownloadApiKeyConfigOptions = {
  id: ApiKey["id"];
  name: ApiKey["name"];
  secret: ApiKey["secret"];
  fileNamePrefix?: string;
  successTitle?: string;
  successMessage?: string;
};

const useDownloadApiKeyConfig = () => {
  const { reportError, reportSuccess } = useTypedContext(FlashContext);

  return useCallback(
    ({
      id,
      name,
      secret,
      fileNamePrefix = "api-key",
      successTitle = "Downloading file credentials",
      successMessage,
    }: DownloadApiKeyConfigOptions) => {
      const secretFile = formatApiSecretFile(secret, id);

      if (!secretFile) {
        reportError({
          message:
            "Something went wrong while generating the API config. Please contact us at support or try again.",
        });

        return false;
      }

      downloadFile(`${fileNamePrefix}-${name}.config`, secretFile);
      reportSuccess({
        title: successTitle,
        message: successMessage ?? `Your credentials file is being downloaded for Key ID: ${id}`,
      });

      return true;
    },
    [reportError, reportSuccess]
  );
};

export default useDownloadApiKeyConfig;
